import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import * as React from 'react';

export const EditIcon = ({ color = '' }) => {
  const styleObj: React.CSSProperties = color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faEdit} size="sm" />;
};
